export const CLR = {
    brandPrimary: '#feee00',
    genHappy: '#3866df',
    body: '#404553',
    bodyLight: '#7e859b',
    bodyLightest: '#b2bbd2',
    greyLight: '#e2e5f1',
    greyMidLight: '#839ba6',
    bgTertiary: '#f7f7fa',
    bgPrimary: '#fff',
    generalWarning: '#ce0f0f',
    green: '#38ae04',
    orange: '#f5a523',
    bgGross: '#f9f9f9',
    border: '#ebedee',
    lightBlueGreyTwo: '#d7d8ea',
    genInactive: '#bbbbbe',
    shadow: '#979797',
    manatee: '#93939a',
    genPositive: '#51ce1a',
    genProcessing: '#FFA500',
    iron: '#d5d7db',
    azure: '#2196f3',
    lemon: '#fffcca',
};

export const NIGHT = {
    brandPrimary: '#3866df',
    genHappy: '#82CFFD',
    body: '#FFFFFF',
    bodyLight: '#f7f7fa',
    bodyLightest: '#515664',
    greyLight: '#515664',
    greyMidLight: '#b2bbd2',
    bgTertiary: '#7e859b',
    bgPrimary: '#404553',
    generalWarning: '#ffaaaa',
    green: '#38ae04',
    orange: '#f5a523',
    bgGross: '#626775',
    border: '#ebedee',
    lightBlueGreyTwo: '#d7d8ea',
    genInactive: '#bbbbbe',
    shadow: '#979797',
    manatee: '#c3c3c3',
    genPositive: '#9ff27b',
    genProcessing: '#FFA500',
    iron: '#d5d7db',
    azure: '#2196f3',
    lemon: '#fffcca',
};

const xsMin = 480;
const smMin = 768;
const mdMin = 992;
const lgMin = 1200;
const maxWidth = 1400;

export const BP = {
    xsMin,
    smMin,
    mdMin,
    lgMin,
    xsMax: xsMin - 1,
    smMax: smMin - 1,
    mdMax: mdMin - 1,
    lgMax: lgMin - 1,
};

export const PAD = {
    xsWrapperPad: '15px',
    smWrapperPad: '30px',
    mdWrapperPad: '45px',
};

export const FONT = {
    xsBase: '12px',
    smBase: '13px',
    mdBase: '14px',
    lgBase: '15px',
    xlgBase: '18px',
    xxlBase: '24px',
};

export const MISC = {
    maxWidth,
};



// WEBPACK FOOTER //
// ./src/styles/_constants.js